export const User = (props) => {
  const { size = 28, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 28 28'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M23.333 24.5c0-1.628 0-2.442-.201-3.105a4.666 4.666 0 00-3.111-3.11c-.663-.202-1.477-.202-3.105-.202h-5.833c-1.628 0-2.443 0-3.105.201a4.667 4.667 0 00-3.111 3.111c-.201.663-.201 1.477-.201 3.105M19.249 8.75a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z'
        ></path>
      </svg>
    </span>
  );
};
